// src/playback-runtime/lifecycle/useAudioContextKeepAlive.ts

"use client";

/*
 iOS Safari suspends audio graph when idle.
 Keep minimal audio context alive.
*/

import { useEffect, useRef } from "react";

export function useAudioContextKeepAlive() {
  const ctxRef = useRef<AudioContext | null>(null);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const AudioCtx = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioCtx) return;

    ctxRef.current = new AudioCtx();

    const resume = () => {
      if (ctxRef.current?.state === "suspended") {
        ctxRef.current.resume();
      }
    };

    // must be user gesture
    window.addEventListener("touchstart", resume, { passive: true });
    window.addEventListener("click", resume);

    return () => {
      window.removeEventListener("touchstart", resume);
      window.removeEventListener("click", resume);
      ctxRef.current?.close();
    };
  }, []);
}
